module.exports = __webpack_public_path__ + "img/agreement_txt_en.439ae595.png";